import { LOGIN_URL, REQUEST_PUBLIC_KEY,GENERATEOTP_URL,VERIFYOTP_URL } from '../../CONSTANTS'
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from 'axios'

export const login = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(LOGIN_URL(), data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in signIn axios!");
                });
        } catch (error) {
            console.error("in userServices > signIn, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};

export const handleVerifyOtp =async(data) =>{
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(VERIFYOTP_URL(), data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in signIn axios!");
                });
        } catch (error) {
            console.error("in userServices > signIn, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
    // try{

    //   const response = await axios
    //   .post(VERIFYOTP_URL(), data);
      
    //   const isVerfied = await response.json();
    // }
    //  catch(e){
    //   console.log(e)
    //   //handle error
    //  }
    }

export const generateOTP = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(GENERATEOTP_URL(), data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in signIn axios!");
                });
        } catch (error) {
            console.error("in userServices > signIn, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};

export const getRequestPublicKey = () => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(REQUEST_PUBLIC_KEY())
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getRequestPublicKey axios!");
                });
        } catch (error) {
            console.error("in LoginService > getRequestPublicKey, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};